import { Network } from '@manifoldxyz/js-ts-utils';
import { DEFAULT_STEP_STATE } from '@/common/constants';
import { getSupportedRelayNetworks } from '@/common/networkUtils';
import {
  StepConfig,
  TransactionStep,
  TransactionStepState,
  TxStepId,
  TxStepStatus,
} from '@/common/types';

export function createConnectStep(
  networkId: number,
  overrideConfig?: Partial<StepConfig>,
  overrideState?: Partial<TransactionStepState>,
): TransactionStep {
  return {
    state: {
      ...DEFAULT_STEP_STATE,
      descriptionByStatus: {
        [TxStepStatus.Unstarted]: 'Allows you to select the wallet you want to pay with',
        [TxStepStatus.Pending]: 'Connect your payment wallet...',
        [TxStepStatus.Confirming]: 'Connecting to wallet...',
        [TxStepStatus.Confirmed]: 'Wallet connected',
        [TxStepStatus.Failed]: 'Connection failed',
      },
      ...overrideState,
    },
    config: {
      id: TxStepId.Connect,
      name: 'Connect Wallet',
      alwaysShow: true,
      SecondaryComponent: () => {
        return (
          <div
            id="m-connect-claim-widget"
            // eslint-disable-next-line tailwindcss/no-custom-classname
            className="manifold-scheme-dark"
            data-widget="m-connect"
            data-enable-network-switching="true"
            data-wallet-connect-project-id="ca03bf2709bfa142a2d9adb0d6e99e7f"
            data-network={
              Network.isTestnet(networkId) ? networkId : getSupportedRelayNetworks(false).join(',')
            }
            data-browser-provider-ignore-disconnect="true"
            data-multi="true"
            data-show-balance="false"
            data-auto-reconnect="false"
            data-override-connect-text="Connect Your Wallet"
          />
        );
      },
      primaryButtonText: 'Connect Wallet',

      ...overrideConfig,
    },
  };
}
